import React, { useContext } from 'react';
import AppContext from '@context';
import When from '@components/ui/When';
import Proposal from './Proposal';
import Skeleton from './Skeleton';
import { JourneyListProposalsMobilePropsInterface } from './JourneyListProposalsMobileTypes';

function JourneyListProposalsMobile({
  handleClick,
}: JourneyListProposalsMobilePropsInterface) {
  const {
    state: {
      proposals: { pending: proposals },
      journeys,
      filters: { isSearching },
    },
  } = useContext(AppContext);
  const loading = proposals.isFetching;

  function renderJourneys() {
    return proposals.data.map((proposal, index, array) => (
      <Proposal
        key={proposal.id}
        {...proposal}
        hasBorder={index + 1 !== array.length || !!journeys.all.data.length}
        onClick={(event) => {
          handleClick(event, proposal);
        }}
      />
    ));
  }
  return (
    <>
      <When isShow={!loading && !isSearching}>{renderJourneys()}</When>
      <When isShow={loading}>
        <Skeleton />
      </When>
    </>
  );
}

export default JourneyListProposalsMobile;
